import {
  adaptReportingsToStore,
  adaptReportToStore,
  adaptReportDownload,
} from './adapters/reportingAdapter'

import { CONTENT_BACKOFFICE } from '@/services/axios.config'
import buildParamList from './utils/build_params'
import { buildServices } from './utils/build_services'

const services = [
  {
    name: 'listReportings',
    method: 'get',
    url: (params) => `/reporting${buildParamList(params)}`,
    resolver: adaptReportingsToStore,
  },
  {
    name: 'downloadReport',
    method: 'get',
    url: (params) => `/reporting/${params.reportId}/download`,
    resolver: adaptReportDownload,
  },
  {
    name: 'createReporting',
    method: 'post',
    url: () => `/reporting`,
    data: (params) => {
      return {
        type: params.type,
        model_id: params.model_id,
        model_type: params.model_type,
        filters: {created_after: params.from, created_before: params.to},
      }
    },
    resolver: adaptReportToStore,
  },
]

export const { listReportings, downloadReport, createReporting } = buildServices(CONTENT_BACKOFFICE, services)
